import { useState } from "react";
import { useRecommendedJobs, useSavedJobs } from "@/app/services/create-resume/queries.js";
import { ResumeDataService } from "@/app/services/create-resume/resume-data.js";

type InteractionType = "Saved" | "Shared" | "Irrevant";

interface UseJobInteractionsReturn {
	submitting: boolean;
	saveJobInteraction: (interaction: InteractionType) => Promise<void>;
}

/**
 * Hook to manage job interaction actions (save, share, mark irrelevant)
 * @param jobId - The job ID to interact with
 * @param dataId - Optional data ID from props
 * @returns Interaction state and handler
 */
export function useJobInteractions(jobId: string, dataId?: string): UseJobInteractionsReturn {
	const [submitting, setSubmitting] = useState(false);
	const jobService = new ResumeDataService();
	const { refetch: refetchRecommendedJobs } = useRecommendedJobs();
	const { refetch: refetchSavedJobs } = useSavedJobs();

	const saveJobInteraction = async (interaction: InteractionType) => {
		setSubmitting(true);
		await jobService.saveJobInteraction(
			dataId || jobId,
			{ interactionType: interaction },
			() => {
				refetchRecommendedJobs();
				refetchSavedJobs();
				setSubmitting(false);
			},
			() => {
				setSubmitting(false);
			},
		);
	};

	return {
		submitting,
		saveJobInteraction,
	};
}
